import { digitsEnToFa } from "persian-tools2";
import * as Yup from 'yup';

const nameAndLastName = (string) =>
  Yup.string()
    .trim()
    .min(3, `${string} شما کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
    .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
    .matches(/^[\u0600-\u06FF\s]+$/, {
      message: `لطفا ${string} بیمار را فارسی وارد کنید.`,
    })
    .nullable(true)
    .required(`لطفا ${string} بیمار را وارد کنید.`);

const validationSchema = Yup.object({
  firstName: nameAndLastName('نام'),
  lastName: nameAndLastName('نام خانوادگی'),
  // phone
  phoneNumber: Yup.string()
    .trim()
    .min(11, `شماره موبایل شما کمتر از ${digitsEnToFa(11)} رقم میباشد.`)
    .max(11, `شماره موبایل شما بیشتر از ${digitsEnToFa(11)} رقم میباشد.`)
    .matches(/^(09)\d{9}$/i, {
      message: `شماره موبایل باید با ${digitsEnToFa('09')} شروع شود.`,
    })
    .required('لطفا شماره موبایل بیمار را وارد کنید.'),
});


export default validationSchema;